import { createContext, useContext } from 'react';

interface ScrollContextType {
  goToSection: (sectionIndex: number) => void;
  currentSection: number;
}

export const ScrollContext = createContext<ScrollContextType | undefined>(undefined);

export const ScrollProvider = ScrollContext.Provider;

export const useScrollNavigation = () => {
  const context = useContext(ScrollContext);
  if (!context) {
    throw new Error('useScrollNavigation must be used within ScrollProvider');
  }
  return context;
};
